module.exports = __webpack_public_path__ + "static/media/img_empty_cart.90402fce.png";